import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

export default function ImageComponent({
	imageItem,
	className,
	alt,
	objectFit,
}) {
	// Check if imageItem exists before proceeding
	if (!imageItem) {
		return null;
	}

	if (imageItem.localFile?.childImageSharp) {
		return (
			<GatsbyImage
				image={imageItem?.localFile?.childImageSharp?.gatsbyImageData}
				alt={
					alt
						? alt
						: imageItem.localFile?.alternativeText
						? imageItem.localFile.alternativeText
						: 'Card Image'
				}
				className={className}
				objectFit={objectFit ? objectFit : ''}
			/>
		);
	} else {
		// Handle relative URLs by prepending the Strapi API URL
		const imageUrl = imageItem?.url?.startsWith('http')
			? imageItem.url
			: `${
					process.env.GATSBY_STRAPI_API_URL ||
					process.env.STRAPI_API_URL ||
					'https://wilaustralia-55061f853444.herokuapp.com'
			  }${imageItem?.url}`;

		return (
			<img
				src={imageUrl}
				alt={
					alt
						? alt
						: imageItem?.alternativeText
						? imageItem.alternativeText
						: 'Card Image'
				}
				className={className}
			></img>
		);
	}
}
